import { render, staticRenderFns } from "./NewcomerGift.vue?vue&type=template&id=b59c76c6&scoped=true&"
import script from "./NewcomerGift.vue?vue&type=script&lang=js&"
export * from "./NewcomerGift.vue?vue&type=script&lang=js&"
import style0 from "./NewcomerGift.vue?vue&type=style&index=0&id=b59c76c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59c76c6",
  null
  
)

export default component.exports